import { Cookies } from 'react-cookie';

import { PoisonAddFormValues, PoisonUsage } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PoisonAdd {
  poison: PoisonAddFormValues;
  id: string;
  slug: string;
}

export const createAppPoison = async ({ poison, id, slug }: PoisonAdd) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/visit_report/${slug}/${id}/add-poison/`,
    {
      ...poison,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as PoisonUsage;
};
